import React from 'react';
import {Modal,ModalOverlay,ModalContent,ModalHeader,ModalCloseButton,ModalBody,Text} from '@chakra-ui/react';
import ChatUserSearch from './ChatUserSearch';
export default function NewAppChat({isOpen,onClose,onSelect}:{isOpen:boolean;onClose:()=>void;onSelect:(user:any)=>void}) {
  return <Modal isOpen={isOpen} onClose={onClose} isCentered><ModalOverlay/><ModalContent><ModalHeader>New app chat</ModalHeader><ModalCloseButton/><ModalBody pb={6}>
    <Text mb={4}>Choose who to message as Pureworker Support. They will receive your message in the app.</Text>
    <ChatUserSearch onSelect={onSelect}/>
  </ModalBody></ModalContent></Modal>;
}
